import React, { useEffect, useState } from 'react';

import useNumberParams from '../../hooks/useNumberParams';
import axios from '../../services/MyAxios';
import ResourceSuperAgents from '../superAgent/ResourceSuperAgents';

import MasterAgentDetails from './MasterAgentDetails';
import MasterAgentMetrics from './MasterAgentMetrics';

function MasterAgentShow() {
    const { id } = useNumberParams();
    const [masterAgent, setMasterAgent] = useState({});
    const url = '/crea/api/master_agent/';
    const metricsUrl = '/crea/api/metrics/';

    useEffect(() => {
        axios.get(`${url + id}?transformStateAndCountryFields`).then((response) => {
            setMasterAgent(response.data);
        });
    }, []);

    return (
        <>
            <MasterAgentMetrics url={metricsUrl + id} />
            <MasterAgentDetails masterAgent={masterAgent} />
            <ResourceSuperAgents url={`${url + id}/super_agents`} />
        </>
    );
}

export default MasterAgentShow;
